import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { DATESTR_FMT } from 'tdr-common';
import DateChecked from '../../icons/date-checked.svg';
import GuestChecked from '../../icons/guest-checked.svg';
import TimeChecked from '../../icons/time-checked.svg';
import styles from './FilterIcons.module.scss';

type FilterIconsProps = {
	groupSize: number;
	date: string;
	time: string;
}

export const FilterIcons = ({ groupSize, date, time }: FilterIconsProps) => {
	const { t, i18n } = useTranslation();

	const formattedDate = (() => {
		if (!date) {
			return '';
		}
		// Try to parse if it matches our canonical format, otherwise assume already formatted
		const parsed = DateTime.fromFormat(date, DATESTR_FMT);
		if (parsed.isValid) {
			return parsed.setLocale(i18n.language === 'fr' ? 'fr-CA' : 'en').toLocaleString({ month: 'long', day: 'numeric' });
		}
		return date;
	})();

	const guestsLabel = groupSize === 1 ? t('labels.guest') : t('labels.guests');

	return (
		<div className={styles.Container}>
			<FilterIcon
				icon={<img src={GuestChecked} alt={t('labels.group_size')} width={20} height={20} />}
				text={`${groupSize} ${guestsLabel}`}
				ariaLabel={t('labels.group_size')}
			/>
			<FilterIcon
				icon={<img src={DateChecked} alt={t('labels.date')} width={20} height={20} />}
				text={formattedDate}
				ariaLabel={t('labels.date')}
				grow
			/>
			<FilterIcon
				icon={<img src={TimeChecked} alt={t('labels.time')} width={20} height={20} />}
				text={time}
				ariaLabel={t('labels.time')}
				grow
			/>

		</div>
	);
};

type FilterIconProps = {
	icon?: React.ReactNode;
	text?: string;
	ariaLabel?: string
	grow?: boolean;
};
const FilterIcon = ({ icon, text, ariaLabel, grow }: FilterIconProps) => {
	return (
		<div
			className={`${styles.Item} ${grow ? styles['Item--grow'] : ''}`}
			aria-label={ariaLabel}
		>
			{icon}
			{text}
		</div>
	);
};